export class EmployeeAccess {
  constructor(
    public codePinAccess: boolean,
    public emailPassAccess: boolean,
    public nfcAccess: boolean,
    public code: string,
    public pin: string
  ) { }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/models/employee-access.ts